import { render } from "./BiodataByAdmin.vue?vue&type=template&id=ce6eb5e2&scoped=true"
import script from "./BiodataByAdmin.vue?vue&type=script&lang=js"
export * from "./BiodataByAdmin.vue?vue&type=script&lang=js"

import "./BiodataByAdmin.vue?vue&type=style&index=0&id=ce6eb5e2&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6eb5e2"]])

export default __exports__